import React from "react"
import { Dispatch } from "redux"

import {
    SetCcReviewReviewHref,
    SetCcReviewReviewEditHref,
    SetCcReviewHref,
    addModal,
} from "client/store"

import ReviewReviewAnswer from "client/pages/cc/review/review/answer"
import ReviewReviewEdit from "client/pages/cc/review/review/itemEdit"

export const OpenAnswer = (
    baseRoute: string,
    activeTab: string,
    fileId: number,
    versionId: number,
    reviewItemId: number,
    revisionId: number,
    dispatch: Dispatch,
) => {
    SetCcReviewReviewHref(baseRoute, activeTab, fileId, versionId, reviewItemId, revisionId)

    dispatch(addModal({
        key: "answer",
        content: <ReviewReviewAnswer reviewItemId={reviewItemId} revisionId={revisionId} />,
        onClose: () => {
            SetCcReviewHref(baseRoute, activeTab, fileId, versionId)
        },
    }))
}

export const OpenEdit = (
    baseRoute: string,
    activeTab: string,
    fileId: number,
    versionId: number,
    reviewItemId: number,
    revisionId: number,
    dispatch: Dispatch,
) => {
    SetCcReviewReviewEditHref(baseRoute, activeTab, fileId, versionId, reviewItemId, revisionId)

    dispatch(addModal({
        key: "editItem",
        content: <ReviewReviewEdit reviewItemId={reviewItemId} revisionId={revisionId} />,
        onClose: () => {
            SetCcReviewHref(baseRoute, activeTab, fileId, versionId)
        },
    }))
}
